import {
  Avatar,
  Box,
  Button,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import UserTable from "../components/UserTable";
import { UserContext } from "../contexts/userContext";
import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase-config";
import { getFormattedDate } from "../utils/utils";
import { IUser } from "../interfaces";
import { roleLabel, USERS_COLLECTION } from "../utils/constants";

const Profile = () => {
  const { userData } = useContext(UserContext);
  const [profile, setProfile] = useState({} as IUser);
  const [employees, setEmployees] = useState([] as IUser[]);
  const [edit, setEdit] = useState(false);
  const userCollectionRef = collection(db, USERS_COLLECTION);

  const handleChange = (type: string, value: string) =>
    setProfile({ ...profile, [type]: value });

  useEffect(() => {
    if (userData) setProfile(userData);
    if (userData.role === "ADMIN") {
      const q = query(
        userCollectionRef,
        where("business", "==", userData.business),
        where("uid", "!=", userData.uid)
      );
      const unsubscribe = onSnapshot(q, (snapshot) => {
        if (snapshot.docs.length)
          setEmployees(
            snapshot.docs.map(
              (doc) =>
                ({
                  ...doc.data(),
                  uid: doc.id,
                  createdAt: new Date(doc.data().createdAt).toLocaleDateString(
                    "es-AR"
                  ),
                  updatedAt: new Date(doc.data().updatedAt).toLocaleDateString(
                    "es-AR"
                  ),
                } as IUser)
            )
          );
      });
      return () => unsubscribe();
    }
  }, [userData, userCollectionRef]);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ width: "100vw", height: "100vh" }}
    >
      <Box
        height="fit-content"
        width="fit-content"
        sx={{
          backgroundColor: "#FFFFFF",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          borderRadius: "10px",
        }}
        mt={10}
        m={3}
        p={3}
      >
        <Grid container width="100%" justifyContent="center" spacing={3}>
          <Grid
            size={{ xs: 12, md: 3 }}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Avatar sx={{ width: 100, height: 100 }} />
          </Grid>
          <Grid
            container
            flexDirection="column"
            spacing={2}
            size={{ xs: 12, md: 9 }}
            p={3}
          >
            <Grid size={{ xs: 12 }} display="flex" justifyContent="end">
              {!edit && (
                <Button
                  variant="text"
                  onClick={() => setEdit(true)}
                  endIcon={
                    <span className="material-symbols-rounded">edit</span>
                  }
                >
                  Editar
                </Button>
              )}
            </Grid>
            <Grid sx={{ xs: 12 }}>
              <Typography>
                Correo verificado:
                {profile.emailVerified ? " Verificado" : " No verificado"}
              </Typography>
            </Grid>
            <Grid sx={{ xs: 12 }}>
              <Typography>Rol: {roleLabel[profile.role]}</Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                size="small"
                label="Nombre"
                onChange={({ target: { value, name } }) =>
                  handleChange(name, value)
                }
                value={profile.name || ""}
                disabled={!edit}
              />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <TextField
                fullWidth
                size="small"
                onChange={({ target: { value, name } }) =>
                  handleChange(name, value)
                }
                label="Correo electronico"
                value={profile.email || ""}
                disabled={!edit}
              />
            </Grid>
            {edit && (
              <Grid
                size={{ xs: 12 }}
                display="flex"
                justifyContent="end"
                mt={3}
                gap={2}
              >
                <Grid size={{ xs: 12, md: 3 }}>
                  <Button
                    fullWidth
                    size="small"
                    variant="outlined"
                    onClick={() => setEdit(false)}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                  <Button
                    fullWidth
                    size="small"
                    variant="contained"
                    onClick={() => setEdit(true)}
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>
          {profile.role === "ADMIN" && <UserTable users={employees} />}
        </Grid>
      </Box>
    </Box>
  );
};

export default Profile;
